import {addMethod, addMethodBatch, numberMethods, dateMethods, textMethods, financialMethods, arrayMethods} from "@xbs/muon";
import group from "../operations/undo_group";

export const methodsWithCategories = {};
export const mathCategories = [];

export function addMathMethods(methods){
	methods = methods || [];
	[
		["date", dateMethods],
		["text", textMethods],
		["number", numberMethods],
		["financial", financialMethods],
		["array", arrayMethods]
	].forEach(arr => {
		if(methods == "all" || methods.indexOf(arr[0]) != -1){
			mathCategories.push(arr[0]);
			addMethodBatch(arr[1]);
			Object.keys(arr[1]).forEach(value => methodsWithCategories[value] = arr[0]);
		}
	});
}

export const htmlMath = ["IMAGE", "HYPERLINK", "SPARKLINE", "CHECKBOX", "RADIO"];

export function init(view){
	const math = {
		IMAGE: url => {
			if(view.config.xssSafe && url.indexOf("data:image/") != 0 && new URL(document.baseURI).origin != new URL(url, document.baseURI).origin)
				return "#XSS!";
			return `<img class="webix_ssheet_cimage" src="${webix.template.escape(url)}">`;
		},
		HYPERLINK: (url, text) => webix.template.escape(text || url),
		SPARKLINE: (arr, type, color1, color2) => {
			const config = { type, color: color1, negativeColor:color2, paddingX:2, paddingY:2 };

			if(type == "donut")
				webix.extend(config, {type:"pie", donut:1}, true);
			else if(type == "barH")
				webix.extend(config, {type:"bar", horizontal:1}, true);

			for(let i = 0 ; i < arr.length; i++)
				arr[i] = arr[i]||0;

			const tableConfig = view.$$("cells").config;

			//[FIXME] we do not know from which cell the method was called, so this is not the real width and height
			const isCircle = config.type == "pie" || type == "radar";
			const width = isCircle ? 100 : tableConfig.columnWidth;
			const height = isCircle ? 100 : tableConfig.rowHeight;
			return webix.Sparklines.getTemplate(config)(arr, { width, height });
		},
		CHECKBOX: state => !!state,
		RADIO: (rowPos, colPos, rowCount, colCount, state) => !!state
	};

	const keys = Object.keys(math);
	keys.forEach((key, i) => addMath(view, key, math[key], i == keys.length - 1));

	const grid = view.$$("cells");
	grid.on_click["ssheet_checkbox"] = function(ev, cell){
		const value = view.getCellValue(cell.row, cell.column, false);
		view.setCellValue(cell.row, cell.column, `=checkbox(${value ? 0 : 1})`);
		view.refresh();
	};
	grid.on_click["ssheet_radio"] = function(ev, cell){
		setRadioState(view, cell.row, cell.column);
	};

	view.attachEvent("onCommand", action =>{
		if(action.id == "add-radio")
			view.addRadio();
		else if(action.id == "add-checkbox")
			view.addCheckbox();
	});

	view.$mathTemplate = mathTemplate;
}

export function setRadioState(view, row, column, state, page){
	const math = view.getCellValue(row, column, true, page);
	if(/^=(radio)\(/i.test(math)){
		const [rowPos, colPos, rowCount, colCount] = math.match(/\((.+?)\)/)[1].split(",").map(v => v.trim());

		if(state === false){
			view.setCellValue(row, column, `=radio(${rowPos}, ${colPos}, ${rowCount}, ${colPos}, 0)`, page);
			view.refresh();
		}
		else{
			const value = view.getCellValue(row, column, false);
			if(!value)
				group.set(()=>{
					for(let r = 1; r <= rowCount; r++)
						for(let c = 1; c <= colCount; c++)
							view.setCellValue(
								row - rowPos + r,
								column - colPos + c,
								`=radio(${r}, ${c}, ${rowCount}, ${colCount}, ${r == rowPos && c == colPos ? 1 : 0})`,
								page
							);
					view.refresh();
				});
		}
	}
}

export function addMath(view, name, handler, sort, category, generateHTML){
	name = name.toUpperCase();
	addMethod(name, handler);

	if(category)
		methodsWithCategories[name] = category;
	if(generateHTML)
		htmlMath.push(name);

	if(view.$$("liveEditor")){
		const formulaButtonViews = webix.$$(view.$$("formulaButton").config.popup).getBody().getChildViews();
		[
			webix.$$(view.$$("liveEditor").config.suggest).getList(),
			formulaButtonViews[3]
		].forEach(list => {
			if(!list.exists(name)){
				list.add({id:name, value:name});
				if(sort)
					list.sort("value", "asc", "string");
			}
		});

		if(category){
			const categoryFilter = formulaButtonViews[0];
			const categoryList = categoryFilter.getList();
			if(!categoryList.exists(category)){
				categoryList.add({id:category, value:webix.i18n.spreadsheet.liveEditor[category]||category});
				if(!categoryFilter.isVisible()) categoryFilter.show();
			}
		}
	}
}

export function getJsDateFromExcel(excelDate) {
	const date = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
	return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

export function getExcelDateFromJs(jsDate) {
	const returnDateTime = 25569 + ((jsDate.getTime() - (jsDate.getTimezoneOffset() * 60000)) / (86400 * 1000));
	return returnDateTime.toString();
}

function mathTemplate(math, value){
	const locale = webix.i18n.spreadsheet.table;
	switch (value){
		case "#REF!":
			return locale["math-ref-error"];
		case "#ERROR":
			return locale["math-error"];
		case "#XSS!":
			return locale["math-xss-error"];
		case "#SPILL!":
			return locale["math-spill-error"];
	}

	if(/^=checkbox\(/i.test(math))
		return `<span class='webix_icon ssheet_checkbox wxi-checkbox-${value ? "marked" : "blank"}'></span>`;
	else if(/^=radio\(/i.test(math))
		return `<span class='webix_icon ssheet_radio wxi-radiobox-${value ? "marked" : "blank"}'></span>`;
	else if(/^=hyperlink\(/i.test(math)){
		let quotes, urlEndPos;
		const startIndex = math.indexOf("(") + 1;
		for(let i = startIndex; i < math.length; i++){
			if(math[i] == "\"") quotes = !quotes;
			else if(math[i] == "," && !quotes){
				urlEndPos = i;
				break;
			}
		}

		if(!urlEndPos)
			urlEndPos = math.indexOf(")");

		const url = this._mData.getStore().exec(math.substring(startIndex, urlEndPos), this._mPage.getContext());
		const escape = webix.template.escape;
		let attrs;

		if(url[0] == "#")
			attrs = `href="javascript:void(0);" class="webix_ssheet_ref" data-ref="${escape(url.substr(1))}"`;
		else
			attrs = `target="blank" href="${escape(url)}"`;

		return `<a ${attrs}>${value}</a>`;
	}

	return value;
}